import { map, range } from 'lodash';
import { FormFieldConfig, SelectOption } from '~/definitions/admin';

export const ALT_CANDS: SelectOption[] = map(range(10), (num) => ({
    value: num.toString(),
    label: num.toString(),
}));

// Form field configuration
export const FORM_FIELDS: Record<string, FormFieldConfig> = {
    election_start_date: {
        type: 'datetime',
        required: true,
        testId: 'start-date-datepicker',
        label: 'Start dato (E-valg)',
    },
    election_end_date: {
        type: 'datetime',
        required: true,
        testId: 'end-date-datepicker',
        label: 'Stopp dato (E-valg)',
    },
    election_next_year: {
        type: 'text',
        required: false,
        testId: 'next-election-year-input',
        label: 'Neste valg (årstall)',
        maxLength: 4,
    },
    election_candidate_elimination: {
        type: 'checkbox',
        required: false,
        testId: 'candidate-elimination-checkbox',
        label: 'Kandidater kan strykes',
    },
    election_number_of_alt_candidates: {
        type: 'select',
        required: false,
        testId: 'alt-cands-select-text',
        options: ALT_CANDS,
        label: 'Antall alternative kandidater årets valg',
    },
    election_model: {
        type: 'select',
        required: true,
        testId: 'model-select-text',
        label: 'Modell',
    },
    election_election_model: {
        type: 'select',
        required: true,
        testId: 'choice-model-select-text',
        label: 'Valgmodell',
    },
    election_description: {
        type: 'textarea',
        required: false,
        testId: 'election-text-text-area',
        extendedClassName: 'h-[120px]',
        label: 'Om valg i Coop tekst',
    },
    election_annual_description: {
        type: 'textarea',
        required: false,
        testId: 'election-annual-text-area',
        extendedClassName: 'h-[120px]',
        label: 'Om årsmøtet',
    },
    election_job_position_city: {
        type: 'select',
        required: false,
        testId: 'show-on-candidate-select-text',
        label: 'Vis felt på kandidat liste',
    },
    election_default_region: {
        type: 'select',
        required: true,
        testId: 'default-region-select-text',
        label: 'Standard stemmeseddel',
    },
};

export const ACTIVE_ATTRIBUTE_NUMBER = 'active';
export const ZIP_CODE_ATTRIBUTE_NUMBER = 'region_zip_code';
